import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import MobileHeroAnimation from './MobileHeroAnimation';
import DesktopHeroAnimation from './DesktopHeroAnimation';

const { FiArrowDownRight } = FiIcons;

const Hero = () => {
  const handleScrollToCalibration = (e) => {
    e.preventDefault();
    const element = document.getElementById('start-calibration');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      window.history.pushState(null, '', '/#/#start-calibration');
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-black pt-44 md:pt-48 lg:pt-96 pb-28 md:pb-48 overflow-hidden">
      {/* Texture Background */}
      <div className="absolute inset-0 bg-[radial-gradient(#ffffff05_1px,transparent_1px)] [background-size:40px_40px] pointer-events-none z-0" />

      {/* Desktop Background Animation */}
      <DesktopHeroAnimation />

      <div className="max-w-[1400px] mx-auto px-6 relative z-10 w-full h-full flex flex-col justify-center">
        <div className="max-w-5xl relative z-20">
          {/* Top Label */}
          <div className="flex items-center gap-4 mb-6 md:mb-8">
            <div className="w-8 h-[1px] bg-[#BEF264]" />
            <span className="text-[#BEF264] font-black uppercase tracking-[0.3em] md:tracking-[0.4em] text-[9px] md:text-[10px] block">
              Working with clients worldwide
            </span>
          </div>

          {/* Main Headline - Locked Left */}
          <motion.h1
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            className="text-[2.75rem] md:text-8xl lg:text-[10rem] font-black text-white leading-[0.95] md:leading-[0.85] tracking-tighter mb-8 md:mb-12 italic max-w-4xl"
          >
            CONTENT <br />
            <span className="text-white not-italic">FOR THOSE WITH </span><br />
            <span className="text-[#BEF264]">STANDARDS.</span>
          </motion.h1>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="flex flex-col md:flex-row items-start md:items-end gap-8 md:gap-12"
          >
            {/* Desktop Paragraph (Left side) */}
            <div className="hidden md:block">
              <p className="text-2xl text-white/70 max-w-xl leading-relaxed tracking-tight font-bold mb-0 drop-shadow-md">
                Living Media is a high-performance video house for founders, creators, and brands who demand aesthetic precision and absolute consistency.
              </p>
            </div>

            {/* Mobile Layout Wrapper with Corrected Order */}
            <div className="flex flex-col w-full md:w-auto md:block">
              
              {/* 1. Body Copy (Mobile Only) */}
              <p className="md:hidden text-sm text-white/60 leading-relaxed tracking-tight font-medium text-center mb-0 px-4">
                Living Media is a high-performance video house for founders, creators, and brands who demand aesthetic precision and absolute consistency.
              </p>

              {/* 2. Animation (Mobile Only) - Visual Focus */}
              <MobileHeroAnimation />
              
              {/* 3. Button (Mobile & Desktop) */}
              {/* Added mb-4 for separation from status text on mobile */}
              <Link
                to={{ pathname: '/', hash: '#start-calibration' }}
                onClick={handleScrollToCalibration}
                className="group flex items-center justify-center md:justify-start gap-4 bg-white text-black p-5 md:p-6 rounded-full font-black uppercase tracking-widest hover:bg-[#BEF264] transition-all relative z-30 mb-4 md:mb-4 w-full md:w-auto"
                aria-label="Book a Video Calibration Call"
              >
                <span>Book Calibration</span>
                <SafeIcon icon={FiArrowDownRight} className="w-6 h-6 group-hover:rotate-45 transition-transform" />
              </Link>

              {/* 4. Availability Label (Mobile & Desktop) */}
              <div className="flex items-center justify-center md:justify-start gap-2 px-6 mb-8 md:mb-0 md:px-0">
                <div className="w-2 h-2 rounded-full bg-[#BEF264] animate-ping" />
                <span className="text-[9px] text-white/30 uppercase tracking-[0.25em] font-bold">Available for Q1 2026</span>
              </div>
              
            </div>
          </motion.div>
        </div>
      </div>

      {/* Footer Text in Hero */}
      <div className="absolute bottom-6 md:bottom-12 left-0 w-full px-6 flex justify-between items-end pointer-events-none z-20">
        <div className="h-[1px] bg-white/20 flex-grow mr-12 hidden md:block" />
        <div className="text-[0.55rem] md:text-[0.65rem] text-white/30 uppercase tracking-[0.4em] md:tracking-[0.5em] font-bold w-full text-center md:text-right md:w-auto">
          Selective • Editorial • Performance
        </div>
      </div>
    </section>
  );
};

export default Hero;